import { Button } from '@monorepo/shared/componentsV2/Button';
import { Checkbox } from '@monorepo/shared/componentsV2/Checkbox';
import TrashIcon from '@svg/trash.svg';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 1.625rem;
`;

type TableBulkActionsProps = {
  areAllVisibleSelected: boolean;
  areAnySelected: boolean;
  areAnyVisibleSelected: boolean;
  isBulkDeleting: boolean;
  onDelete: () => void;
  onToggleAllVisibleRows: (isChecked: boolean) => void;
};

export function TableBulkActions({
  areAllVisibleSelected,
  areAnySelected,
  areAnyVisibleSelected,
  isBulkDeleting,
  onDelete,
  onToggleAllVisibleRows,
}: TableBulkActionsProps) {
  return (
    <Container>
      <Checkbox
        checked={areAllVisibleSelected}
        disabled={isBulkDeleting}
        indeterminate={areAnyVisibleSelected && !areAllVisibleSelected}
        label="Select all"
        onChange={(evt) => onToggleAllVisibleRows(evt.target.checked)}
      />
      {areAnySelected && (
        <Button disabled={isBulkDeleting} onClick={onDelete}>
          <TrashIcon />
          {isBulkDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      )}
    </Container>
  );
}
